import React, { useMemo, useRef } from 'react';
import withTranslation from 'hoc/withTranslation';
import NewJobMarkers from '../NewJobMarkers';
import NewStopMarkers from '../NewStopMarkers';
import NewUnselectedStopMarkers from '../NewUnselectedStopMarkers';
import NewStartEndLocations from '../NewStartEndLocations';
import NewActivityMarkers from '../NewActivityMarkers';

const NewMapMarker = ({ display, map, mapData, ui, user, oAuth }) => {
  const prevFeaturesRef = useRef(null);

  const memoizedGeoJSON = useMemo(() => {
    if (!mapData?.geo?.features) return mapData;

    const currentFeatures = mapData.geo.features;
    const prevFeatures = prevFeaturesRef.current?.features;

    if (prevFeatures && currentFeatures.length === prevFeatures.length) {
      let hasChanged = false;

      for (let i = 0; i < currentFeatures.length; i++) {
        const curr = currentFeatures[i];
        const prev = prevFeatures[i];

        if (
          curr.properties?.id !== prev.properties?.id ||
          curr.geometry?.coordinates?.[0] !== prev.geometry?.coordinates?.[0] ||
          curr.geometry?.coordinates?.[1] !== prev.geometry?.coordinates?.[1] ||
          curr.properties?.isEditing !== prev.properties?.isEditing ||
          curr.properties?.isPickup !== prev.properties?.isPickup ||
          curr.properties?.highPriority !== prev.properties?.highPriority
        ) {
          hasChanged = true;
          break;
        }
      }

      if (!hasChanged) {
        return prevFeaturesRef.current.geoJSON;
      }
    }

    prevFeaturesRef.current = {
      geoJSON: mapData,
      features: currentFeatures,
    };

    return mapData;
  }, [mapData]);

  return (
    <>
      {display.showProblem && (
        <NewJobMarkers map={map} geoJSON={memoizedGeoJSON} ui={ui} user={user} oAuth={oAuth} />
      )}
      {!display.showProblem && (
        <NewUnselectedStopMarkers
          map={map}
          geoJSON={memoizedGeoJSON}
          ui={ui}
          user={user}
          display={display}
        />
      )}
      {!display.showProblem && <NewStopMarkers map={map} geoJSON={memoizedGeoJSON} ui={ui} user={user} display={display} />}
      <NewActivityMarkers map={map} geoJSON={memoizedGeoJSON} ui={ui} user={user} display={display} />
      <NewStartEndLocations map={map} geoJSON={memoizedGeoJSON} ui={ui} user={user} display={display} />
    </>
  );
};

export default withTranslation(NewMapMarker);
